import React, { useState } from 'react';
import {
    Paper,
    Typography,
    Grid,
    Button,
    Container,
    CircularProgress,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    useTheme,
} from '@material-ui/core';
import 'react-notifications-component/dist/theme.css'; // Asegúrate de importar el CSS de estilos
import { useForm } from 'react-hook-form';
import clsx from 'clsx';

import { useDispatch, useSelector } from 'react-redux';
import { useStyles } from './SinginStyles';
import { RestartPass } from '../../../centraldevida/domain/api/UsersApi';

import { selectLoading } from '../../domain/userSlice';
import { Copyright } from '../../../dashboard/componet/UI/CopyRight';
export default function ForgotPass(props) {
    const {formState: { errors } } = useForm();
    const classes = useStyles();
    const borderRadius = clsx(classes.padding, classes.borderRadius);
    const dispath = useDispatch();
    const theme = useTheme(); // Obtén el tema

    const primaryColor = theme.palette.primary.main;
    const isLoading = useSelector(selectLoading);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenCorreo, setIsModalOpenCorreo] = useState(false);

    const [email, setEmail] = useState("");


    const handleForgotPassword = () => {
        setIsModalOpen(false);
        if (props.onBackToSignIn) {
            props.onBackToSignIn();
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleCloseModalCorreo = () => {
        setIsModalOpenCorreo(false);
    };



    const Restart = async () => {
        try {
            const request = {
                to: email,
            };

            const response = await RestartPass(dispath, request);
            if (response.code === 'Ex00') {
                setIsModalOpen(true)
            } else {
                if (response.message === 'El correo electrónico ingresado no existe') {
                    setIsModalOpenCorreo(true)
                }

            }
        } catch (error) {
            console.error(error);

        }

    };
    const inputStyles = {
        border: `1px solid ${primaryColor}`,
        color: 'black',

    };


    return (
        <div className={classes.centerv}>
            <Container maxWidth="xs" alignitems="center">
                <Paper className={borderRadius}>
                    <div className={classes.margin}>
                        <Grid container justifyContent="center" style={{ marginTop: '15px' }}>
                            <img
                                src="https://orus-centraldevida.s3.amazonaws.com/Logos/EVBI+-+Logo__3.png"
                                width="150"
                                height="150"
                                alt="Logo"
                            />
                        </Grid>
                        <Typography variant="body1" gutterBottom style={{ textAlign: 'center', marginTop: '30px' }} color='primary' className='textRecuperar'>
                            Por favor ingresa tu correo y te enviaremos una contraseña provisional.
                        </Typography>
                        <form >
                            <Grid container spacing={8} alignItems="flex-end" style={{ marginTop: '15px' }}>
                                <Grid item></Grid>
                                <Grid item md={true} sm={true} xs={true} style={{ padding: '32px 32px 32px 0px' }}>
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            color="#d4dfe3"
                                            placeholder="E-mail"
                                            label="E-mail"
                                            name="email"
                                            type="email"
                                            style={inputStyles}
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            className={errors.email ? classes.errorInput : classes.input} // Aplica clases de error o normal
                                        />
                                        {errors.email && (
                                            <Typography variant="body2" color="error" className={classes.errorMessage}>
                                                {errors.email.message}
                                            </Typography>
                                        )}
                                    </div>
                                </Grid>
                            </Grid>
                            <div className={classes.wrapper}>
                                <Grid
                                    container
                                    justifyContent="center"
                                    style={{ marginTop: '20px', width: '50%', marginLeft: '25%', marginBottom: '10%' }}
                                >
                                    <Button
                                        disabled={isLoading}
                                        type="button"
                                        variant="contained"
                                        color="primary"
                                        style={{ textTransform: 'none', width: '45%' }}
                                        onClick={handleForgotPassword}
                                    >
                                        Volver
                                    </Button>
                                    <div style={{ width: '10%' }}></div>
                                    <Button
                                        disabled={isLoading}
                                        type="button"
                                        variant="contained"
                                        color="primary"
                                        style={{ textTransform: 'none', width: '45%' }}
                                        onClick={Restart}
                                    >
                                        Enviar
                                    </Button>
                                </Grid>
                                {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </div>
                        </form>
                    </div>
                    <Copyright />
                </Paper>
            </Container>
            <Dialog open={isModalOpen} onClose={handleCloseModal}>
                <DialogTitle>Correo Enviado</DialogTitle>
                <DialogContent>
                    <DialogContentText>Se te ha enviado un correo con los datos para que puedas ingresar.</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleForgotPassword} color="primary">
                        Volver
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={isModalOpenCorreo} onClose={handleCloseModalCorreo}>
                <DialogTitle color='red'>ERROR</DialogTitle>
                <DialogContent>
                    <DialogContentText>El correo electronico que ingresaste no existe, ingresa un correo valido</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseModalCorreo} color="primary">
                        cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
